import { render } from "./CameraIcon.vue?vue&type=template&id=6dd120d4&ts=true"
import script from "./CameraIcon.vue?vue&type=script&lang=ts"
export * from "./CameraIcon.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__